import React from 'react'
import Layout from '../Layout'

export default function termsOfService(props) {
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    return (
        <Layout props={props}>
            <div className="px-5 py-4 stctPgWrpr">
                {/* <h2>About Us</h2> */}
                {!isBargainsProject ? (
                    <span
                        dangerouslySetInnerHTML={{
                            __html: global.storeDetails.fact_to_know,
                        }}
                    ></span>
                ) : (
                    <span
                        dangerouslySetInnerHTML={{
                            __html: global.storeDetails.terms_condition,
                        }}
                    ></span>
                )}
            </div>
        </Layout>
    )
}
